module.exports = __webpack_public_path__ + "img/mile5m.4e15d0cb.jpg";